import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@coin/shared/core/util-environments';
import { Observable } from 'rxjs';
import { OrganisationSnapshot } from '@coin/shared/core/util-models';
import { encodeSeasonType } from '@coin/shared/core/util-helpers';
import { SeasonTypeEnum } from '@coin/shared/core/util-enums';
import { LoadingService } from './loading/loading.service';
import { HttpHelpersService } from './http-helpers';

/** @deprecated Use the equivalent from `@coin/shared/core/data-access-v2` instead. */
@Injectable({
  providedIn: 'root'
})
export class OrganisationSnapshotService {
  private httpClient = inject(HttpClient);
  private loadingService = inject(LoadingService);
  private httpHelper = inject(HttpHelpersService);

  public getOrganisationSnapshot(
    seasonType: SeasonTypeEnum,
    seasonId: string,
    organisationSnapshotId: string
  ): Observable<OrganisationSnapshot> {
    return this.httpClient
      .get<OrganisationSnapshot>(
        `${environment.api.baseUrl}/admin/api/v1/${encodeSeasonType(seasonType)}/seasons/${seasonId}/snapshots/organisations/${organisationSnapshotId}`
      )
      .pipe(this.loadingService.withLoadingScreen, this.httpHelper.handleError('Cannot get organisation snapshot'));
  }
}
